import { format, isToday, isYesterday, parseISO } from "date-fns";
import { ru } from "date-fns/locale";

export const formatReportDateISO = (isoDate: string): string => {
    const date = parseISO(isoDate);

    if (isToday(date)) return "Обновлено сегодня";
    if (isYesterday(date)) return "Обновлено вчера";

    const formatString = date.getFullYear() === new Date().getFullYear() ? "d MMMM" : "d MMMM yyyy";
    return `Обновлено ${format(date, formatString, { locale: ru })}`;
};

export const formatReportDateUnix = (unixTimestamp: number): string => {
    const date = new Date(unixTimestamp * 1000);

    if (Number.isNaN(date.getTime())) return "";

    if (isToday(date)) return "сегодня";
    if (isYesterday(date)) return "вчера";

    const formatString = date.getFullYear() === new Date().getFullYear() ? "d MMMM" : "d MMMM yyyy";
    return `${format(date, formatString, { locale: ru })}`;
};